import { ProductClassificationEnum } from '@enum/productClassification.enum';
import { PlpPageRouteEnum } from '@app/routes/enum/plpPageRoute.enum';
import { IKeyValue } from '@interfaces/keyValue.interface';

export interface IPlpFilters extends IKeyValue {
  productClassification?: string;
}

export const plpFilterProductType = {
  BROADLOOM: 'Broadloom',
  CARPET_TILE: 'Carpet Tile',
  WALK_OFF_TILE: 'Walk Off Tile',
  LUXURY_VINYL_TILE: 'Luxury Vinyl Tile',
  ULTIMATE_FLEX_LVT: 'Ultimate Flex LVT',
  RESILIENT_SHEET: 'Resilient Sheet',
  LAMINATED_WOOD: 'Laminated Wood',
  WALL_BASE: 'Wall Base',
  STAIR_SOLUTIONS: 'Stair Solutions',
  INSTALLATION: 'Installation'
};

const {
  BROADLOOM,
  CARPET_TILE,
  WALK_OFF_TILE,
  LUXURY_VINYL_TILE,
  ULTIMATE_FLEX_LVT,
  RESILIENT_SHEET,
  LAMINATED_WOOD,
  WALL_BASE,
  STAIR_SOLUTIONS,
  INSTALLATION
} = plpFilterProductType;

export const plpFilterClassificationBasedProductType = {
  SOFT_SURFACE: new Set([BROADLOOM, CARPET_TILE, WALK_OFF_TILE]),
  HARD_SURFACE: new Set([LUXURY_VINYL_TILE, ULTIMATE_FLEX_LVT, RESILIENT_SHEET, LAMINATED_WOOD]),
  ACCESSORIES: new Set([STAIR_SOLUTIONS, WALL_BASE, INSTALLATION])
};

export const plpFilterConstants = {
  COLLECTION_STYLE: 'COLLECTION OR STYLE',
  PRODUCT_TYPE: 'PRODUCT TYPE',
  QUICKSHIP_ONLY: 'QUICKSHIP ONLY',
  FILTER: 'Filter',
  RESET_ALL: 'Reset All',
  APPLY: 'Apply',
  CLEAR_ALL: 'Clear All',
  SEARCH: 'Search',
  SELECT: 'Select'
};

export const excludedFilter = ['product_type', 'quickShip'];

export const plpFilterKeys = {
  PRODUCT_TYPE: 'product_type',
  QUICK_SHIP: 'quickShip',
  FIBER_TYPE: 'fiber_type',
  BACKING_TYPE: 'backing_type',
  SURFACE_APPEARANCE: 'surface_appearance',
  COLORS: 'colors',
  COLOR_FAMILY: 'color_family',
  DYE_METHOD: 'dye_method',
  FACE_WEIGHT: 'face_weight',
  PRODUCT_SIZE: 'productSize',
  CONSTRUCTION: 'construction',
  CONSTRUCTION_TYPE: 'constructiontype',
  INSTALLATION_METHODS: 'installation_methods',
  WEAR_LAYER: 'wear_layer',
  THICKNESS: 'thickness',
  PRODUCT_CLASSIFICATION: 'ProductClassification',
  INSTALLATION: 'Installation'
} as const;

export const plpFilters: IPlpFilters[] = [
  {
    key: PlpPageRouteEnum.CARPET,
    productClassification: ProductClassificationEnum.SOFT_SURFACE,
    value: [
      'product_type',
      'quickShip',
      'fiber_type',
      'backing_type',
      'surface_appearance',
      'colors',
      'color_family',
      'dye_method',
      'face_weight',
      'productSize'
    ]
  },
  {
    key: PlpPageRouteEnum.HARD_SURFACE,
    productClassification: ProductClassificationEnum.HARD_SURFACE,
    value: [
      'product_type',
      'constructiontype',
      'Installation',
      'productSize',
      'wear_layer',
      'thickness',
      'surface_appearance'
    ]
  },
  {
    key: PlpPageRouteEnum.ACCESSORIES,
    productClassification: ProductClassificationEnum.ACCESSORIES,
    value: ['product_type']
  },
  {
    key: PlpPageRouteEnum.SEARCH,
    value: ['product_type', 'quickShip']
  }
];

export const allPlpFilter = plpFilters.flatMap((filter) => filter?.value ?? '');
